import { render, staticRenderFns } from "./GlobalSearchBlog.vue?vue&type=template&id=104f138e&"
import script from "./GlobalSearchBlog.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchBlog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports